import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import '../../assets/css/react-colorful.css';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { securedAxiosInstance } from '../../api/axios';

const TagModal = ({ isOpen, onClose }) => {
  const [color, setColor] = useState('#00B3B0');
  const schema = yup
    .object({
      tagName: yup.string().required('Tag name is required'),
    })
    .required();

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async data => {
    const result = await securedAxiosInstance.post('resource_tags', {
      name: data.tagName,
      colour: color,
    });
    const tagData = {
      color: color,
      label: data.tagName,
      value: result.data.id,
    };
    reset();
    onClose(tagData);
  };
  return (
    <Modal
      onClose={() => onClose(false)}
      closeOnOverlayClick={false}
      size={'xs'}
      isOpen={isOpen}
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalContent>
          <ModalHeader>Tag</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={'2'}>
              <FormControl id="tagName" isInvalid={errors.tagName}>
                <FormLabel>Tag name</FormLabel>
                <Input id="tagName" {...register('tagName')} />
                <FormErrorMessage>
                  {errors.tagName && errors.tagName.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="tagColor">
                <FormLabel
                  display={'inline-block'}
                  pr={'4'}
                  sx={{ borderRight: `24px solid ${color}` }}
                >
                  Color
                </FormLabel>
                <HexColorPicker color={color} onChange={setColor} />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button
              variant="outline"
              onClick={() => onClose(false)}
              disabled={isSubmitting}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default TagModal;
